// extracted by mini-css-extract-plugin
export default {"block":"RequestReasonPriority_block__Aywjw"};